export class RoomTabs {
    constructor() {
        const termsHeader = document.querySelector('.terms_header')
        let that = this;

        if (termsHeader) {
            this.init(that);
        }
    }

    init(that) {

        const allTerms = document.querySelectorAll('.terms_header .btn')

        that.initial()
        that.changeRoom(null, that);


        allTerms.forEach(
            function (e) {
                e.addEventListener('click', function (el) {
                    allTerms.forEach(function (element) {
                        element.classList.remove('active')
                    })
                    el.currentTarget.classList.add('active')
                    let termCurrent = el.currentTarget.getAttribute('data-term')
                    that.changeRoom(termCurrent, that);
                })
            }
        )
    }

    changeRoom(termCurrent, that) {
        const allRoomsNav = document.querySelectorAll('.room_nav_panel .nav-room')
        const termRoomNav = document.querySelectorAll(".room_nav_panel .nav-room[data-term=" + termCurrent + "]")
        if (termCurrent) {
            allRoomsNav.forEach(function (el) {
                el.classList.remove('active')
                el.classList.remove('active-panel')
            })
        }

        that.firstChild(termRoomNav)


        allRoomsNav.forEach(function (e) {

            let termRoom = e.getAttribute('data-term')
            if (termCurrent && termCurrent === termRoom) {
                e.classList.add('active')
            }
            e.addEventListener('click', function (element) {
                allRoomsNav.forEach(function (elem) {
                    elem.classList.remove('active-panel')
                })

                e.classList.add('active-panel')
                that.changeSlide(element.currentTarget.getAttribute('data-room'));
            })
        })
    }

    changeSlide(slugCurrentRoom) {
        const allSlides = document.querySelectorAll('.room_content_panel .slide')

        allSlides.forEach(function (e) {
            e.classList.remove('active')
        })

        if (slugCurrentRoom) {
            allSlides.forEach(function (el) {
                let slugRoom = el.getAttribute('data-room')
                if (slugRoom === slugCurrentRoom) {
                    el.classList.add('active')
                }
            })
        }
    }

    initial() {
        const activeTerm = document.querySelector('.terms_header .btn.active')
        if (activeTerm) {
            let term = activeTerm.getAttribute('data-term')
            let queryTerm = "[data-term=" + term + "]";

            let rooms = document.querySelectorAll(".room_nav_panel .nav-room" + queryTerm)
            rooms.forEach(function (e) {
                e.classList.add('active')
            })

            rooms[0].classList.add('active-panel')
            let roomSlug = "[data-room=" + rooms[0].getAttribute('data-room') + "]"
            let slideCurrent = document.querySelector('.room_content_panel .slide' + roomSlug)
            if (slideCurrent) {
                slideCurrent.classList.add('active')
            }
        }
    }

    firstChild(termRoomNav) {
        if (termRoomNav.length > 0) {
            const slugRoomSlide = document.querySelector(".room_content_panel .slide[data-room=" + termRoomNav[0].getAttribute('data-room') + "]")
            const allSlide = document.querySelectorAll(".room_content_panel .slide")
            termRoomNav[0].classList.add('active-panel')
            allSlide.forEach(function (el) {
                el.classList.remove('active')
            })
            slugRoomSlide.classList.add('active')
        }
    }
}
